import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { RefundRequestPreviewComponent } from '../refund-request-preview/refund-request-preview.component';

@Component({
  selector: 'app-add-video-image-for-redund-request',
  templateUrl: './add-video-image-for-redund-request.component.html',
  styleUrls: ['./add-video-image-for-redund-request.component.scss'],
})
export class AddVideoImageForRedundRequestComponent {
  public modalData: any = {};
  public loader: boolean = false;
  public editFormData: any = null;
  public formfieldrefreshdata: any = null;
  public formfieldrefresh: any = null;
  public userformdata: any = null;
  login_user_details: any;
  userID: any;
  userType: any;

  constructor(
    public dialogRef: MatDialogRef<AddVideoImageForRedundRequestComponent>,
    private apiservice: ApiservicesService,
    public cookieService: CookieService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
    console.log('data==============>', data);
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('login_user_details===12354>', this.login_user_details);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.modalData = this.data;
    console.log('modalDatarequest===123654789========>', this.modalData);
    this.userID = this.login_user_details.userinfo._id;
    this.userType = this.login_user_details.userinfo.user_type;

    this.initializeForm();
  }

  initializeForm() {
    console.log('this.formValue?.icon_image========', this.editFormData?.image);

    // Always start with base userformdata config
    this.userformdata = {
      successmessage: 'Added Successfully !!',
      submittext: 'Submit',
      apiUrl: this.apiservice.baseUrl,
      resettext: 'Reset',
      canceltext: 'Cancel',
      hidereset: this.editFormData ? true : false,
      jwttoken: '',
      fields: [] as any[],
    };

    // Add fields conditionally
    if (this.modalData?.image_only) {
      this.userformdata.fields.push({
        label: 'Upload Images',
        name: 'image',
        type: 'file',
        multiple: true,
        prefix: Date.now(),
        path: 'divine-infinity-being/refund-assets/',
        baseurl: 'divine-infinity-being/refund-assets/',
        bucket: 'all-frontend-assets',
        apiurl: this.apiservice.baseUrl + 'user-profile/request-bucket-url',
        apideleteurl:
          this.apiservice.baseUrl + 'user-profile/delete-image-from-bucket',
      });
    } else if (this.modalData?.video_only) {
      this.userformdata.fields.push({
        label: 'Upload Videos',
        name: 'video',
        type: 'file',
        multiple: true,
        prefix: Date.now(),
        path: 'divine-infinity-being/refund-assets',
        baseurl: 'divine-infinity-being/refund-assets',
        bucket: 'all-frontend-assets',
        apiurl: this.apiservice.baseUrl + 'user-profile/request-bucket-url',
        apideleteurl:
          this.apiservice.baseUrl + 'user-profile/delete-image-from-bucket',
      });
    }
  }

  getS3Url(img: any): string {
    const base = (img?.baseurl || img?.path || '').replace(/^\/|\/$/g, '');
    const key = base ? `${base}/${img.fileservername}` : img.fileservername;
    return `https://s3.us-east-1.amazonaws.com/${
      img.bucket
    }/${encodeURIComponent(key).replace(/%2F/g, '/')}`;
  }

  listenFormFieldChange(val: any) {
    console.log('listenFormFieldChange', val);

    if (val && val.field) {
      if (val.field === 'formcancel') {
        this.onNoClick();
        this.apiservice
          .getHttpDataPost('refund-processing/refund-request-list-details', {
            _id: this.modalData.return_request_id,
          })
          .subscribe(
            (res: any) => {
              if (res.status === 'success') {
                const dialogRef = this.dialog.open(
                  RefundRequestPreviewComponent,
                  {
                    panelClass: 'custom-modalbox',
                    data: {
                      value: res.results || {},
                    },
                  }
                );
                this.loader = false;

                return;
              } else {
                this.matSnackBar.open(
                  'Failed to load order preview.',
                  'Close',
                  {
                    duration: 3000,
                    panelClass: ['snackbar-error'],
                  }
                );
                this.loader = false;
                this.dialogRef.close();
              }

              return;
            },
            (err) => {
              console.error('Order preview error:', err);
              this.matSnackBar.open(
                'Something went wrong while loading preview.',
                'Close',
                {
                  duration: 3000,
                  panelClass: ['snackbar-error'],
                }
              );
              this.loader = false;
              return;
            }
          );
      }

      if (val.field === 'fromsubmit') {
        this.loader = true;
        const formData = val.fromval;

        let payload: any;
        if (this.modalData?.image_only) {
          payload = {
            image: formData.image || [],
            return_request_id: this.modalData.return_request_id,
          };
        } else if (this.modalData?.video_only) {
          payload = {
            video: formData.video || [],
            return_request_id: this.modalData.return_request_id,
          };
        }

        console.log('Payload---------->>', payload);

        // ✅ Check if payload is valid and not empty
        if (
          (payload.image && payload.image.length > 0) ||
          (payload.video && payload.video.length > 0)
        ) {
          this.apiservice
            .getHttpDataPost(
              'refund-processing/update-refund-image-video',
              payload
            )
            .subscribe({
              next: (response: any) => {
                if (response.status === 'success') {
                  this.matSnackBar.open(
                    'Media uploaded successfully!',
                    'Close',
                    {
                      duration: 3000,
                      panelClass: ['snackbar-success'],
                    }
                  );

                  const actorName =
                    this.login_user_details?.userinfo?.name ||
                    this.login_user_details?.userinfo?.firstname +
                      (this.login_user_details?.userinfo?.lastname
                        ? ' ' + this.login_user_details.userinfo.lastname
                        : '') ||
                    'User';

                  const mediaType = this.modalData?.image_only
                    ? 'images'
                    : 'videos';
                  const uploadedFiles = this.modalData?.image_only
                    ? formData.image
                    : formData.video;

                  interface ActivityPayload {
                    user_id: any;
                    refundRequestId: any;
                    type: string;
                    description: string;
                    actor: {
                      userId: any;
                      role: any;
                      name: any;
                      email: any;
                    };
                    metadata?: {
                      [key: string]: any;
                    };
                  }

                  const activityPayload: ActivityPayload = {
                    user_id: this.modalData.user_id,
                    refundRequestId: this.modalData.return_request_id,
                    type: 'ATTACHMENT_ADDED',
                    description: `Added new ${mediaType} to the request.`,
                    actor: {
                      userId: this.login_user_details?.userinfo?._id,
                      role: this.login_user_details?.userinfo?.user_type,
                      name: actorName,
                      email: this.login_user_details?.userinfo?.email || '',
                    },
                  };

                  if (
                    Array.isArray(uploadedFiles) &&
                    uploadedFiles.length > 0
                  ) {
                    activityPayload.metadata = {
                      [mediaType.slice(0, -1)]: this.getS3Url(uploadedFiles[0]),
                    };
                  }

                  this.apiservice
                    .getHttpDataPost(
                      'refund-activity/refund-activity-add',
                      activityPayload
                    )
                    .subscribe({
                      next: () => {
                        console.log(
                          'Activity for media addition logged successfully.'
                        );
                      },
                      error: (err) => {
                        console.error(
                          'Failed to log activity for media addition:',
                          err
                        );
                      },
                    });

                  this.apiservice
                    .getHttpDataPost(
                      'refund-processing/refund-request-list-details',
                      {
                        _id: this.modalData.return_request_id,
                      }
                    )
                    .subscribe(
                      (res: any) => {
                        if (res.status === 'success') {
                          const dialogRef = this.dialog.open(
                            RefundRequestPreviewComponent,
                            {
                              panelClass: 'custom-modalbox',
                              data: {
                                value: res.results || {},
                              },
                            }
                          );
                          this.loader = false;
                          this.dialogRef.close();
                        } else {
                          this.matSnackBar.open(
                            'Failed to load order preview.',
                            'Close',
                            {
                              duration: 3000,
                              panelClass: ['snackbar-error'],
                            }
                          );
                          this.loader = false;
                          this.dialogRef.close();
                        }
                      },
                      (err) => {
                        console.error('Order preview error:', err);
                        this.matSnackBar.open(
                          'Something went wrong while loading preview.',
                          'Close',
                          {
                            duration: 3000,
                            panelClass: ['snackbar-error'],
                          }
                        );
                        this.loader = false;
                      }
                    );
                } else {
                  this.matSnackBar.open(
                    response.message || 'Failed to submit request.',
                    'Close',
                    { duration: 3000, panelClass: ['snackbar-error'] }
                  );
                }
                this.loader = false;
              },
              error: (err) => {
                console.error('API Error:', err);
                this.matSnackBar.open(
                  'An error occurred. Please try again.',
                  'Close',
                  { duration: 3000, panelClass: ['snackbar-error'] }
                );
                this.loader = false;
              },
            });
        } else {
          // ✅ Show message when no media selected
          this.matSnackBar.open(
            'Please select an image or video before submitting.',
            'Close',
            { duration: 3000, panelClass: ['snackbar-error'] }
          );
          this.loader = false;
        }
      }

      if (val.field === 'formreset') {
        this.formfieldrefreshdata = { field: 'description', value: '' };
      }
    }
  }
}
